import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/legal")({
  component: lazyRouteComponent(() => import("./+Legal")),
  head: () => ({
    meta: seo({ title: "Terms of Sale" }),
  }),
});
